import { updateRegion } from "../../../../../actions/Utilities/Region";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";
import { editStateRegion } from "../atoms/atoms";
import { useRecoilState } from "recoil";
import useSendEmail from "../../hooks/useSendEmail";

const useUpdateRegion = () => {
  const queryClient = useQueryClient();
  const [, setActionEditState] = useRecoilState(editStateRegion);
  const { mutateAsync: sendEmail } = useSendEmail();

  const { mutate } = useMutation(
    (regionNewData) => updateRegion(regionNewData),
    {
      onSuccess: (res) => {
        if (res === "Duplicate") {
          toast.fire(
            "Saving Failed",
            "Region Name or Region Code already exists!",
            "warning"
          );
        } else {
          queryClient.invalidateQueries(["GetRegion"]);
          sendEmail(res.data, {
            onSuccess: (res) => {
              if (res) {
                if (res.status === 400) {
                  toast.fire(
                    "Success",
                    "Region Updated Successfully, but failed in sending email",
                    "warning"
                  );
                } else {
                  toast.fire(
                    "Success",
                    "Region Updated Successfully",
                    "success"
                  );
                }
              }
            },
          });
          setActionEditState(false);
        }
      },
      onError: () => {
        toast.fire("Failed", "Failed to Update Region!", "error");
      },
    }
  );
  return mutate;
};
export default useUpdateRegion;
